import { useEffect, useState } from "react";

export default function NodeNumberField(props: {
  label: string;
  value: number;
  onChange: (value: number) => void;
  disabled?: boolean;
}) {
  const [displayValue, setDisplayValue] = useState(String(props.value));

  useEffect(() => {
    setDisplayValue(String(props.value));
  }, [props.value]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value;
    // Allow empty, digits, and single dot
    if (val === "" || /^\d*\.?\d*$/.test(val)) {
      setDisplayValue(val);
      const num = val === "" ? 0 : Number(val);
      if (!isNaN(num) && num >= 0) {
        props.onChange(num);
      }
    }
  };

  const handleBlur = () => {
    // Clean up display on blur
    setDisplayValue(String(props.value || 0));
  };

  return (
    <div className="flex flex-col w-full gap-[8px] noDrag nowheel">
      <div className="font-medium text-creator-text text-[14px]">
        {props.label}
      </div>
      <div
        className={
          "flex w-full border-solid items-center border-[2px] h-[32px] rounded-full px-[4px] transition-colors " +
          (props.disabled
            ? "border-creator-border bg-creator-surface"
            : "border-creator-primary bg-creator-primary-background")
        }
      >
        <div className="flex items-center w-full h-full px-[12px] gap-[10px] text-creator-text-sub text-[20px]">
          <input
            type="text"
            inputMode="decimal"
            value={displayValue}
            onChange={props.disabled ? undefined : handleChange}
            onBlur={handleBlur}
            readOnly={props.disabled}
            aria-disabled={props.disabled}
            className={
              "w-full min-w-0 font-normal text-[12px] text-creator-text-sub focus:outline-none bg-transparent " +
              (props.disabled
                ? "cursor-not-allowed text-creator-text-faded pointer-events-none select-none"
                : "")
            }
            style={{
              backgroundColor: "transparent",
              WebkitAppearance: "none",
              appearance: "none",
              boxShadow: "none",
              WebkitBoxShadow: "0 0 0 1000px transparent inset",
              WebkitTextFillColor: props.disabled
                ? "var(--pi-disabled)"
                : "var(--pi-menu-text-color-1)",
            }}
          />
        </div>
      </div>
    </div>
  );
}
